/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const LtiLaunchDataLoggingSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('LTI_LAUNCH_DATA_LOGGING')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class LtiLaunchDataLoggingSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return LtiLaunchDataLoggingSettingParser.decode(input).map(res => new LtiLaunchDataLoggingSetting(res));
    }
    static unsafeDecode(input) {
        return LtiLaunchDataLoggingSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LtiLaunchDataLoggingSettingParser.encode(data);
    }
    static schema() {
        return LtiLaunchDataLoggingSettingParser.schema();
    }
}
